var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"canvascontainer",staticClass:"canvas-container-animation-spine-goforgold-medal",attrs:{"id":`canvas-container-animation-spine-goforgold-medal-${_vm.index}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }